import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-skill-category-video-product",
  "use": "icon-skill-category-video-product-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-skill-category-video-product\">\r\n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n    <path d=\"M4.5 7.5h15l-1 13H5.5l-1-13Z\" />\r\n    <path d=\"M8.5 8V6.25a3.5 3.5 0 0 1 7 0V8\" />\r\n    <path d=\"m10 11.25 5 3.25-5 3.25v-6.5Z\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol